export default "__VITE_ASSET__tqVayyHb__"